import Logger from '../logger';
import Instance from '../instance';
import uniqId from 'uniq-id';

var generateUUID = uniqId.generateUUID('xxxxyxxxxyxxxxyxxxxyxxxxyxxxxyxxxxyxxxxy', 32);

function capitalize(str) {
    return str[0].toUpperCase() + str.slice(1, str.length);
}

class Base {
    constructor(options) {
        options = options || {};
        options.instance = options.instance || {};

        var _ = this;

        _.name = options.name;
        _.data = [];

        _.instance               = options.instance || {};
        _.instance._model        = _;
        _.instance.mixins        = _.instance.mixins || [];
        _.instance.props         = _.instance.props || {};
        _.instance.relationships = _.instance.relationships || {};
        _.instance.computed      = _.instance.computed || {};
        _.instance.methods       = _.instance.methods || {};
    }

    _connect(superstore, key) {
        var _ = this;

        Object.defineProperty(_, '_superstore', {
            value: superstore,
            enumerable: false,
            writable: false
        });

        Object.defineProperty(_, '_key', {
            value: key,
            enumerable: false,
            writable: false
        });

        _.logger = new Logger({
            debug: superstore.logger.debug,
            logger: superstore.logger,
            prefix: _.constructor.name + ':' + key + ' ~>',
        });

        _._buildRelationships(_.instance.relationships);

        _.extendable = Instance.extend(_.instance);

        superstore.models[key] = _;
        superstore.data[key] = _.data;

        _.logger.log('connected', _);

        return _;
    }

    _buildRelationships(relationships) {
        var _ = this;

        if (relationships) {
            Object.keys(relationships).forEach(function(key) {
                var relationship = relationships[key];

                if (relationship.type === 'hasMany') {
                    relationship.primaryKey = relationship.primaryKey || 'id';

                    if (relationship.foreignKey) {
                        _.instance.computed[key] = function _computedHasMany() {
                            var __ = this;

                            return _._superstore.data[key].filter(function(record) {
                                return record[relationship.foreignKey].indexOf(__[relationship.primaryKey]) !== -1;
                            });
                        };

                        _.instance.methods['add' + capitalize(key)] = function _addHasMany() {
                            var __ = this,
                                records = Array.prototype.slice.call(arguments);

                            // TODO: Create if needed

                            for (var i = records.length - 1; i >= 0; i--) {
                                records[i][relationship.foreignKey].push(__[relationship.primaryKey]);
                            }

                            return records;
                        };
                    } else {
                        relationship.foreignKey = relationship.foreignKey || 'id';

                        _.instance.computed[key] = function _computedHasManyIds() {
                            var __ = this;

                            return _._superstore.data[key].filter(function(record) {
                                return __[relationship.primaryKey].indexOf(record[relationship.foreignKey]) !== -1;
                            });
                        };

                        _.instance.methods['add' + capitalize(key)] = function _addHasManyIds() {
                            var __ = this,
                                records = Array.prototype.slice.call(arguments);

                            // TODO: Create if needed

                            for (var i = records.length - 1; i >= 0; i--) {
                                __[relationship.primaryKey].push(records[i][relationship.foreignKey]);
                            }

                            return records;
                        };
                    }
                } else if (relationship.type === 'belongsTo') {
                    _.instance.computed[key] = function _computedHasAndBelongsToMany() {
                        return _._superstore.data[key];
                    };
                }

                _.logger.log('relationship:' + key, _.instance.computed[key].name);
            });
        }

        return _.instance.computed;
    }

    build(attrs) {
        attrs = attrs || {};
        attrs.id = attrs.id ? attrs.id + '' : generateUUID();

        var _ = this,
            instance = new _.extendable();

        Object.assign(instance, attrs);

        Object.defineProperty(instance, '_model', {
            value: _,
            enumerable: false,
            writable: false
        });

        Object.defineProperty(instance, 'logger', {
            value: new Logger({
                debug: _.logger.debug,
                logger: _.logger,
                prefix() {
                    return instance._logId + ' ~>';
                }
            }),
            enumerable: false,
            writable: false
        });

        return instance;
    }

    query() {
        var _ = this;

        return _.data;
    }

    save(item) {
        var _ = this,
            changes = item.changes();

        item.updateLastSaved();

        if (_.data.indexOf(item) === -1) {
            _.data.push(item);
        }

        _.logger.log('saved', item._logId, changes);

        return item;
    }

    destroy(item) {
        var _ = this;

        _.data.splice(_.data.indexOf(item), 1);

        _.logger.log('destroyed', item._logId);

        return item;
    }
}

export default Base;
